/**
 * Onboarding - 完善资料页常量
 */

// 音乐流派选项
export const GENRES = [
  { label: 'Afrobeats', value: 'afrobeats', id: 1 },
  { label: 'Hip Hop', value: 'hiphop', id: 2 },
  { label: 'R&B', value: 'rnb', id: 3 },
  { label: 'Pop', value: 'pop', id: 4 },
  { label: 'Dancehall', value: 'dancehall', id: 5 },
  { label: 'Soul', value: 'soul', id: 6 },
  { label: 'Jazz', value: 'jazz', id: 7 },
  { label: 'Electronic', value: 'electronic', id: 8 },
  { label: 'Rock', value: 'rock', id: 9 },
  { label: 'Indie', value: 'indie', id: 10 },
] as const;

// 情绪/氛围选项
export const MOODS = [
  { label: 'Happy', value: 'happy', id: 1 },
  { label: 'Energetic', value: 'energetic', id: 2 },
  { label: 'Chill', value: 'chill', id: 3 },
  { label: 'Sad', value: 'sad', id: 4 },
  { label: 'Party', value: 'party', id: 5 },
  { label: 'Romantic', value: 'romantic', id: 6 },
  { label: 'Focus', value: 'focus', id: 7 },
] as const;

// 国家/地区选项
export const COUNTRIES = [
  { label: 'Nigeria', value: 'NG' },
  { label: 'Tanzania', value: 'TZ' },
  { label: 'Uganda', value: 'UG' },
  { label: 'Côte d\'Ivoire', value: 'CI' },
  { label: 'Kenya', value: 'KE' },
  { label: 'Angola', value: 'AO' },
  { label: 'Cameroon', value: 'CM' },
  { label: 'Zambia', value: 'ZM' },
  { label: 'Burkina Faso', value: 'BF' },
  { label: 'Ghana', value: 'GH' },
  { label: 'Mali', value: 'ML' },
  { label: 'South Africa', value: 'ZA' },
] as const;

// 表单字段名
export const FORM_FIELDS = {
  profilePicture: 'profilePicture',
  dateOfBirth: 'dateOfBirth',
  country: 'country',
  instagram: 'instagram',
  twitter: 'twitter',
  spotify: 'spotify',
  apple: 'apple',
  tiktok: 'tiktok',
  genre: 'genre',
  mood: 'mood',
  bio: 'bio',
} as const;

// 头像上传配置
export const AVATAR_UPLOAD_CONFIG = {
  accept: 'image/jpeg,image/png',
  maxSize: 5 * 1024 * 1024, // 5MB
  ratio: 1, // 1:1 比例
} as const;

// 国家代码
export const PHONE_PREFIXES = [  
  { label: '+234', value: '+234' },
  { label: '+255', value: '+255' },
  { label: '+256', value: '+256' },
  { label: '+225', value: '+225' },
  { label: '+254', value: '+254' },
  { label: '+244', value: '+244' },
  { label: '+237', value: '+237' },
  { label: '+260', value: '+260' },
  { label: '+226', value: '+226' },
  { label: '+233', value: '+233' },
  { label: '+223', value: '+223' },
  { label: '+27', value: '+27' },
];

// export const PHONE_PREFIXES = [  
//   { label: 'Nigeria (+234)', value: '+234' },
//   { label: 'Tanzania (+255)', value: '+255' },
//   { label: 'Uganda (+256)', value: '+256' },
//   { label: 'Côte d\'Ivoire (+225)', value: '+225' },
//   { label: 'Kenya (+254)', value: '+254' },
//   { label: 'Angola (+244)', value: '+244' },
//   { label: 'Cameroon (+237)', value: '+237' },
//   { label: 'Zambia (+260)', value: '+260' },
//   { label: 'Burkina Faso (+226)', value: '+226' },
//   { label: 'Ghana (+233)', value: '+233' },
//   { label: 'Mali (+223)', value: '+223' },
//   { label: 'South Africa (+27)', value: '+27' },
// ];

// 艺人角色
export const ARTIST_ROLES = [
  { label: 'Singer', value: 'singer' },
  { label: 'Rapper', value: 'Rapper' },
  { label: 'Songwriter', value: 'songwriter' },
  { label: 'Beatmaker', value: 'Beatmaker' },
  { label: 'Producer', value: 'producer' },
  { label: 'DJ', value: 'dj' },
  { label: 'Instrumentalist', value: 'instrumentalist' },
  { label: 'Group/Duo', value: 'Group/Duo' },
];

// 社交媒体平台
export const SOCIAL_PLATFORMS = [
  { label: 'Instagram', value: 'instagram' },
  { label: 'Twitter', value: 'twitter' },
  { label: 'TikTok', value: 'tiktok' },
  { label: 'YouTube', value: 'youtube' },
  // { label: 'Spotify', value: 'spotify' },
];

// 简介字数限制
export const BIO_MAX_LENGTH = 500;
